module.exports = __webpack_public_path__ + "img/icon-schedule.1d4f4c74.svg";